<template>
  <v-card :class="[$style.wrapper, overlay && $style.overlay, transparent && $style.transparent]">
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  name: 'PageWrapper',
  props: {
    overlay: Boolean,
    transparent: Boolean,
  },
}
</script>
<style lang="scss" module>
.wrapper{
  min-height: calc(100vh - #{$toolbarHeight} - 2rem);
  @media(max-width: $tabletWidth) {
    min-height: calc(100vh - #{$toolbarHeight} - 8rem);
    overflow: auto;
  }
  &.transparent{
    background: transparent!important;
    box-shadow: none!important;
  }
}
</style>
